import React, { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import LinearProgress from "@mui/material/LinearProgress";
import { useQuery } from "@apollo/client/react";
import Skeleton from "@mui/material/Skeleton";
import EntitySelect from "../../../components/EntitySelect";
import useAuth from "../../../hooks/useAuth";
import { CLIENTS_AND_PROJECTS_QUERY } from "../../../constants/graphql/queries";

export default function Step1({ loading, onBack, onSubmit }) {
  const [selectedClient, setSelectedClient] = useState(null);
  const { user } = useAuth();
  const { settings } = user.company;
  const label = settings?.filter_field1 || "Client";
  const { data: { clients = [] } = {}, loading: loadingClients } = useQuery(
    CLIENTS_AND_PROJECTS_QUERY
  );
  const clientList = clients
    .filter(client => !client.disabled)
    .map(({ id, name }) => ({ id, name }));

  const handleBack = () => {
    onBack();
  };

  const handleSubmit = () => {
    onSubmit({ clientId: selectedClient });
  };

  const handleChangeClient = client => {
    setSelectedClient(client.id);
  };

  return (
    <>
      <DialogContent>
        <Box minHeight={300} display="flex" alignItems="center">
          <Box width={320} margin="0 auto">
            <Typography align="center" fontSize={18} sx={{ mb: 4 }}>
              {`Which other ${label.toLowerCase()} would you like to share access to?`}
            </Typography>
            {loadingClients ? (
              <Skeleton variant="rectangular" height={40} />
            ) : (
              <EntitySelect
                fullWidth
                label={label}
                name="client"
                value={selectedClient}
                suggestions={clientList}
                onChange={handleChangeClient}
              />
            )}
          </Box>
        </Box>
      </DialogContent>
      <LinearProgress variant="determinate" value={100} />
      <Box px={2} py={1.5} display="flex" justifyContent="flex-end" alignItems="center">
        <Box display="flex" gap={1}>
          <Button variant="outlined" color="primary" onClick={handleBack} sx={{ minWidth: 100 }}>
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            sx={{ minWidth: 100 }}
            disabled={!selectedClient || loading}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </>
  );
}
